import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App.jsx';
import { store } from './store.js';
import "./i18n";

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <div data-testid="app-root">
        <App />
      </div>
    </Provider>
  </StrictMode>
);
